import React, { useEffect, useRef } from 'react';
import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import styles from './EditorExtension_RawHtml.module.css';
import { useCCContext } from '../CC/CCContext';
import { CC } from '../CC/CC';
import * as ccUtils from '../CC/utils';
import { generateQuery, replaceBasketIdSubqueries, postWithCache } from '../CC/utils';

export default Node.create({
  name: 'reactComponentRawHtml',
  group: 'inline',
  inline: true,
  atom: true,
  addAttributes() {
    return {
      selected: {
        default: false,
        parseHTML: (element) => element.getAttribute('data-selected') === 'true',
        renderHTML: (attributes) => ({
          'data-selected': attributes.selected
        }),
      },
      html: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-html'),
        renderHTML: (attributes) => ({
          'data-html': attributes.html
        }),
      }
    }
  },
  parseHTML() {
    return [{ tag: 'RawHtml' }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['RawHtml', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});

const Component = (props) => {
  const { selected, updateAttributes } = props;
  const { html } = props.node.attrs;
  const componentRef = useRef({});

  useEffect(() => {
    const handleSelection = () => {
      updateAttributes({ selected: props.editor.isActive('reactComponentRawHtml') });
    };
    props.editor.on('selectionUpdate', handleSelection);
    return () => {
      props.editor.off('selectionUpdate', handleSelection);
    };
  }, [props.editor, updateAttributes]);

  const handleDoubleClick = (event) => {
    console.log('handleDoubleClick');
    if (props.editor.isEditable) {
      event.stopPropagation();
      const { html } = props.node.attrs;
      const customEvent = new CustomEvent('showInsertContentPopup', {
        detail: {
          extension: 'RawHtml',
          props: { html },
          pos: props.getPos(),
          node: props.node
        },
        bubbles: true,
        cancelable: true
      });
      event.target.dispatchEvent(customEvent);
    }
  };

  return (
    <NodeViewWrapper as="span" className={`react-component ${selected ? 'selected' : ''}`}>
      <span
        className={styles.hyperlink}
        onDoubleClick={handleDoubleClick}
        dangerouslySetInnerHTML={{
          __html: html
        }}
      />
    </NodeViewWrapper>
  );
};
